/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";

export type SupportsShutdownRequest = {
  agentId: string;
};

/** @internal */
export type SupportsShutdownRequest$Outbound = {
  agent_id: string;
};

/** @internal */
export const SupportsShutdownRequest$outboundSchema: z.ZodType<
  SupportsShutdownRequest$Outbound,
  z.ZodTypeDef,
  SupportsShutdownRequest
> = z.object({
  agentId: z.string(),
}).transform((v) => {
  return remap$(v, {
    agentId: "agent_id",
  });
});

export function supportsShutdownRequestToJSON(
  supportsShutdownRequest: SupportsShutdownRequest,
): string {
  return JSON.stringify(
    SupportsShutdownRequest$outboundSchema.parse(supportsShutdownRequest),
  );
}
